import LoginEvent from './modules/login/services/loginEvent';
import * as En from '../translations/en.json';
import * as Sv from '../translations/sv.json';
import template from '../views/breadcrumbs/template.html';

export default function config($httpProvider, $translateProvider, $breadcrumbProvider, FanoutProvider, $provide, $qProvider) {

    $qProvider.errorOnUnhandledRejections(false);

    var interceptor = ($rootScope, $q, $timeout, LateRequest, $injector) => {
        var loginEvent = new LoginEvent($rootScope);
        var calls = 0;

        var tokenExceptions = [
            'token_not_provided',
            'token_expired',
            'token_invalid'
        ];

        var spinnerStart = function() {
            $timeout(() => {
                if (calls > 0) {
                    $rootScope.$emit("spinner:start");
                }
            }, 500);        // If the calls takes longer then 500 ms
            calls++;
        };

        var spinnerStop = function() {
            calls--;
            $timeout(() => {
                if (calls === 0) {
                    $rootScope.$emit("spinner:stop");
                }
            })
        };

        return {
            request: (config) => {
                spinnerStart();
                return config || $q.when(config);
            },

            requestError: (rejection) => {
                spinnerStop();
                return $q.reject(rejection);
            },

            response: (response) => {
                spinnerStop();
                return response || $q.when(response);
            },

            responseError: (rejection) => {
                spinnerStop();

                if (rejection.status === 500) {
                    $rootScope.$broadcast('event:server.error');
                } else if (rejection.status === 401) {
                    rejection.data.error === 'token_expired' ? loginEvent.refresh() : loginEvent.required();
                    return LateRequest.add(rejection)
                } else if (rejection.status === 403) {
                    // Access denied
                } else if (rejection.status === 400) {
                    if (tokenExceptions.indexOf(rejection.data.error) != -1) {
                        loginEvent.required();
                        return LateRequest.add(rejection)
                    }
                } else if (rejection.status === 524) { // Restart on Origin Time-out
                    return $injector.get('$http')(rejection.config)
                }

                return $q.reject(rejection);
            }
        }
    };

    $httpProvider.interceptors.push(interceptor);

    $translateProvider.translations('en', En);
    $translateProvider.translations('sv', Sv);

    $translateProvider.preferredLanguage('sv');


    $breadcrumbProvider.setOptions({
        template: template
    });

    FanoutProvider.setUrl('https://b52f1ea7.fanoutcdn.com/bayeux');

    // ignore error message "Possibly unhandled rejection: canceled" which is caused by angular-bootstrap-ui tooltip directive
    $provide.decorator("$exceptionHandler", ['$delegate', $delegate => {
        return (exception, cause) => {
            if (exception === 'Possibly unhandled rejection: canceled') {
                return;
            }
            $delegate(exception, cause);
        };
    }]);

}

/*@ngInject*/
config.$inject = ['$httpProvider', '$translateProvider', '$breadcrumbProvider', 'FanoutProvider', '$provide', '$qProvider'];
